(function AgentVideoCategoryFilterForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentVideoCategoryFilter',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var selected_tab = '';
		var category_id  = '';

		$form.find("#agentvideocategoryfilter-category").on('change', function viewCategory() {
			localStorage.setItem('category_id', $("option:selected", this).val());

			selected_tab    = $('.current-video-tab').val();
			window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + $("option:selected", this).val();
		});

		$form.find("#agentvideocategoryfilter-subcategory").on('change', function viewCategory() {
			selected_tab    = $('.current-video-tab').val();
			category_id     = localStorage.getItem('category_id');
			window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + category_id + '/' + $("option:selected", this).val();
		});
	};

}(jQuery, window.Adzuki || {}));
